import React from 'react';

//Hooks
import { useSelector } from "react-redux";

//Components
import { ChevronLeft, ChevronRight } from "react-feather";

//Styles
import Styles from './Calendar.module.scss';

//Utils
import moment from "moment";

const WeekPicker = ({ startDate, hasNext, hasPrev, handleChange, periodicity }) => {
    const { locale } = useSelector(({ locales }) => locales);
    let start, end;

    if (periodicity === 'monthly') {
        start = startDate.clone().locale(locale).startOf('month');
        end = startDate.clone().locale(locale).endOf('month');
    } else {
        start = startDate.clone().locale(locale);
        end = startDate.clone().locale(locale).add(1, 'week');
    }

    return (
        <div className={Styles.container}>
            {!start.isBefore(moment()) && (
                <button className={Styles.arrowButton} onClick={() => handleChange('left', periodicity)} disabled={!hasPrev}>
                    <ChevronLeft className={Styles.arrow} size={28}/>
                </button>
            )}

            <span className={Styles.title}>
                {`${moment(start).format('DD')}${moment(start).month() !== moment(end).month() ? ` ${moment(start).format('MMMM')}` : ''} - ${moment(end).format('DD')} ${moment(end).format('MMMM')}`}
            </span>

            <button className={Styles.arrowButton} onClick={() => handleChange('right', periodicity)} disabled={!hasNext}>
                <ChevronRight className={Styles.arrow} size={28}/>
            </button>
        </div>
    )
};

export default WeekPicker